import * as React from 'react';
import { JSDOM } from 'jsdom';
import DOMPurify from 'dompurify';

const window = new JSDOM('').window;
const purify = DOMPurify(window);


export interface IPrivacyPolcy {
    policyHtml: string;
}

const sanitizeHtml = (dirty:string) => ({
    __html: purify.sanitize(
        dirty,
        {
            ALLOWED_TAGS: ['a', 'b','em','li','ol','p','span','strong','ul'],
            ALLOWED_ATTR: ['href', 'style','target','title']
        }
    )
});


const PrivacyPolicy = (props: IPrivacyPolcy) => {
    return (
        <div dangerouslySetInnerHTML={sanitizeHtml(props.policyHtml)}/>
  );
};

export default PrivacyPolicy;
